import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinusIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 1,
	viewBox: "0 0 11 1",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5 0.4375C10.5 0.553532 10.4539 0.664812 10.3719 0.74686C10.2898 0.828907 10.1785 0.875 10.0625 0.875H0.4375C0.321468 0.875 0.210188 0.828907 0.128141 0.74686C0.0460937 0.664812 0 0.553532 0 0.4375C0 0.321468 0.0460937 0.210188 0.128141 0.128141C0.210188 0.0460937 0.321468 0 0.4375 0H10.0625C10.1785 0 10.2898 0.0460937 10.3719 0.128141C10.4539 0.210188 10.5 0.321468 10.5 0.4375Z",
		fill: "currentColor"
	})
});
export default SvgMinusIcon;
